import React from "react";

import BaseFoo from "./Base";

const Base = Object.assign({}, React);

class BaseComponent extends BaseFoo(Base.Component) {}
class BasePureComponent extends BaseFoo(Base.PureComponent) {}

Base.Component = BaseComponent;
Base.PureComponent = BasePureComponent;

export default Base;



// WEBPACK FOOTER //
// ./src/App/component/Base/index.js